module.exports = __webpack_public_path__ + "img/svg/trophy-lost.496a78894ce78d9a792d5a43594157d7.svg";